import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const confirmToast = ({ message, onConfirm }) => {
toast.info(
({ closeToast }) => (
<div className="flex flex-col gap-3">
<p className="font-medium text-slate-800">{message}</p>

<div className="flex justify-end gap-3">
<button
onClick={closeToast}
className="px-3 py-1 text-sm bg-slate-200 rounded hover:bg-slate-300"
>
Cancel
</button>

<button
onClick={() => {
closeToast();
onConfirm();
}}
className="px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700"
>
Confirm
</button>
</div>
</div>
),
{
autoClose: false,
closeOnClick: false,
draggable: false,
}
);
};
